
import { Parallax } from 'react-parallax';
import { HashLink } from "react-router-hash-link";
import ImageGallery from 'react-image-gallery';

import "react-image-gallery/styles/css/image-gallery.css"; //this is required by gallery

export default function AboutChika() {
  const photosIndices = [1, 2, 3, 4, 5, 6];
  let images = [];
  for (let i in photosIndices) {
    images.push({
      original: `photos/chika/${photosIndices[i]}.jpg`,
      thumbnail: `photos/chika/small${photosIndices[i]}.jpg`
    })
  }

  return (
    <div>

      <Parallax strength={300} bgImage="photos/chika/4.jpg">
        <div className="section no-pad-bot">

          <div className="container ">
            <h1 className="header center text-lighten-2">Čika</h1>
            <div className="row">
              <div className="col l6 s12">
                <p>
                  Čika pas mus atkeliavo iš veislyno Mano Areka.
                  Ji buvo vienintelė vadoje, tad dėmesio su niekuo nereikėjo dalintis.
                  Atvykus susipažinti su būsima šeimos nare pastebėjome, jog ji kaip gyvas sidabras,
                  visur jos pilna, visur ji dalyvauja ir neduoda ramybės nei savo mamai nei seneliai
                  bei nei kiek joms nenusileidžia.
                  Apie jos valdingą charakterį informavo ir veisėjai, tačiau tas nei kiek mus neatgrasė, greičiau atvirkščiai.
                  Taip vieną šaltą žiemos vakarą į mūsų namus atkeliavo Čika.
                  Ji labai miela bei draugiška su vaikais, tačiau su pastaraisiais ji ne tiek žaidžia kiek prižiūri.
                  Lauke vaikams nubėgus toliau nuo mūsų, Čika visada nuskuba juos parsivesti,
                  vienų nepalieka, kol jie negrįžta arčiau mūsų.
                  Ypač šiai merginai patinka maudytis, vasarą mielai lenda į vandenį ir plaukioja.
                  Čikai, kaip ir daugumai Bostono Terjerų žaidimai yra vienas didžiausių malonumų.
                  Kamuoliuką gali gaudyti ištisą dieną nejaučiant saiko, tad reikia riboti, ypač karštą vasaros dieną.
                  Po intensyvaus žaidimo ateina laikas miegui su nedideliu knarkimu.
                  Tai labai šiluma mėgstantis šuo, žiemą iš po dekiu išlenda tik pažaisti ir pavalgyti.
                  Ši mergina mums suteikia daug džiaugsmo bei meilės.
                </p>
                <p> Čikai reguliariai daromi akių bei klubo sąnario tyrimai, rezultatai nepriekaištingi.
                  Papildomai atliktas akių kataraktos genetinis testas galimam paveldimumui nustatyti, blogų genų nėra.
                </p>
                <p>Dėl būsimų šuniukų vados prašau <HashLink to="#kontaktai">susisiekite su mumis.</HashLink></p>
              </div>
            </div>
          </div>
        </div>
      </Parallax>

      <div className="container">
        <div className="row center">
          <h2>Čikos galerija</h2>
        </div>
        <div className="row center">
          <ImageGallery items={images} slideInterval={2000} />
        </div>
        <a href="/docs/chika1.pdf" target="_blank" rel="noopener noreferrer">Kilmės dokumentas.</a>
        <br />
        <a href="/docs/chika2.pdf" target="_blank" rel="noopener noreferrer">Kelio sąnarių klinikinio įvertinimo sertifikatas. (patella 0/0)</a>
        <br />
        <a href="/docs/chika3.pdf" target="_blank" rel="noopener noreferrer">Akių tyrimo dokumentas.</a>

      </div>

    </div>
  );

}
